/** The three outbox content tabs. */
export enum Tabs {
	CHAT = "CHAT",
	CAMPAIGN = "CAMPAIGN",
	FEED = "FEED",
}

/** Query param the active tab is persisted under in the URL. */
export const TAB_PARAM = "tab";

/**
 * Reads the active outbox tab from the current URL's query string, falling back
 * to the default (CAMPAIGN) when the param is missing or not a known tab value.
 */
export const getTabFromUrl = (search: string = window.location.search): Tabs => {
	const value = new URLSearchParams(search).get(TAB_PARAM);

	return Object.values(Tabs).includes(value as Tabs) ? (value as Tabs) : Tabs.CAMPAIGN;
};
